import {
	Box,
	Button,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
	TextField,
	Grid,
} from '@mui/material'
import {
	GridColDef,
	GridRowSelectionModel,
	useGridApiRef,
} from '@mui/x-data-grid-premium'
import {
	GridContainer,
	PageContainer,
	PageTop,
	SearchContainer,
	StyledDataGrid,
} from 'components/ApplicationStyles'
import PagePosition from 'components/PagePosition'
import { useEffect, useState } from 'react'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'
import { confirmAlert } from '../../../util/util'
import { koKR } from '@mui/x-data-grid-premium/locales'
import { apiProductSave, apiProductList } from 'api/api'
import { SpRequestType } from 'constants/types'

const Product = () => {
	// 이 페이지는 프로시저 호출 테스트를 위해 대충 작성한 예제 코드임
	const actionSave = () => {
		const array = [
			{
				categoryId: 1,
				productName: '333',
				code: '222',
				manufacturer: '샘숭',
				price: 1100,
				isActive: 1,
				crud: 'C',
			},
		]

		const request: SpRequestType = {
			cmd: 'SAVE',
			jsonText: JSON.stringify(array),
		}

		apiProductSave(request).then((res) => {
			console.log(res)
		})
	}

	const actionUpdate = () => {
		const array = [
			{
				id: 6,
				categoryId: 1,
				productName: '테스트111111',
				code: '1111',
				manufacturer: '샘숭',
				price: 1000,
				isActive: 1,
				crud: 'U',
			},
		]

		const request: SpRequestType = {
			cmd: 'UPDATE',
			jsonText: JSON.stringify(array),
		}

		apiProductSave(request).then((res) => {
			console.log(res)
		})
	}

	const actionDelete = () => {
		const array = [
			{
				id: 5,
				crud: 'D',
			},
		]

		const request: SpRequestType = {
			cmd: 'DELETE',
			jsonText: JSON.stringify(array),
		}

		apiProductSave(request).then((res) => {
			console.log(res)
		})
	}

	const actionSearch = () => {
		const request = {
			id: null,
			categoryId: null,
			productName: '11',
		}

		apiProductList(request).then((res) => {
			console.log(res)
		})
	}

	const apiRef = useGridApiRef()
	const [rowSelectionModel, setRowSelectionModel] =
		useState<GridRowSelectionModel>({ type: 'include', ids: new Set() })

	const [disabledAdd] = useState(true)
	const [disabledDel] = useState(true)
	const [disabledSave] = useState(true)
	const [disabledSearch] = useState(true)
	const [disabledReset] = useState(true)
	const [disabledExcelDownload] = useState(false)
	const [hideAdd] = useState(true)
	const [hideDel] = useState(true)
	const [hideSave] = useState(true)
	const [hideSearch] = useState(true)
	const [hideReset] = useState(true)
	const [hideExcelDownload] = useState(false)
	const [loading, setLoading] = useState(false)

	// 추가
	const actionAdd = () => {}

	// 삭제
	const actionDel = () => {}

	// 저장
	// const actionSave = () => {}

	// 검색
	// const actionSearch = () => {}

	// 초기화
	const actionReset = () => {}

	// 키보드 엔터키 처리
	const onKeyUp = (e: React.KeyboardEvent<HTMLFormElement>) => {
		if (e.code === 'Enter') {
			actionSearch()
		}
	}
	return (
		<PageContainer>
			<PageTop>
				<PagePosition
					actionAdd={actionAdd}
					actionDel={actionDel}
					actionSave={actionSave}
					actionSearch={actionSearch}
					actionReset={actionReset}
					actionExcelDownload={() => {}}
					disabledAdd={disabledAdd}
					disabledDel={disabledDel}
					disabledSave={disabledSave}
					disabledSearch={disabledSearch}
					disabledReset={disabledReset}
					disabledExcelDownload={disabledExcelDownload}
					hideAdd={hideAdd}
					hideDel={hideDel}
					hideSave={hideSave}
					hideSearch={hideSearch}
					hideReset={hideReset}
					hideExcelDownload={hideExcelDownload}
				/>
				<SearchContainer onKeyUp={onKeyUp}>
					<Grid
						container
						spacing={2}
					>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
					</Grid>
				</SearchContainer>
			</PageTop>
			<GridContainer>
				<StyledDataGrid
					apiRef={apiRef}
					columns={[]}
					rows={[]}
					showToolbar
					loading={loading}
					localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
				/>
			</GridContainer>
		</PageContainer>
	)
}

export default Product
